import React, { useEffect } from 'react';
import { Box, Button, Container, CssBaseline, Stack, useTheme } from '@mui/material';
import { Outlet, useNavigate, useLocation } from 'react-router';


const Login = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const locArr = location.pathname.split('/');
  const sepOverview = locArr[1] === 'sep' && !isNaN(+locArr[2]);
  const sepDetail = locArr[1] === 'details' && !isNaN(+locArr[2]);
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === 'dark';

  useEffect(() => {
    document.body.style.backgroundColor = isDarkMode ? theme.palette.background.default : theme.palette.backgroundColors.default || '';
  }, [theme.palette.mode]);
  return (
    <>
      <CssBaseline />
      <Box
        component="main"
        sx={{
          mx: { xs: 2, sm: 2, md: 2, lg: 2, xl: 2 },
          p: 0,
          height: '100%',
          minHeight: 0,
          overflow: 'hidden'
        }}
      >
        <Container
          maxWidth={false}
          disableGutters={true}
          sx={{
            height: '100%',
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          {(sepOverview || sepDetail) ? (
            <Box
              className="no-print"
              sx={{
                position: 'sticky',
                top: 0,
                backgroundColor: isDarkMode ? theme.palette.background.default : theme.palette.backgroundColors.default || '',
                zIndex: 8,
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <Button
                variant="text"
                className="no-print"
                onClick={() => navigate(-1)}
                sx={{ px: 2, height: 40, my: { xs: 1, sm: 1, md: 1, lg: 2, xl: 2 } }}
              >
                <i className="fa-solid fa-angle-left"></i>&nbsp;&nbsp;Back
              </Button>
            </Box>
          ) : (
            <Box sx={{ mt: { xs: 2, sm: 2, md: 2, lg: 2, xl: 2 } }}></Box>
          )}
          <Container
            className="section-to-print"
            maxWidth={false}
            sx={{
              bgcolor: isDarkMode ? theme.palette.background.default : theme.palette.white.main,
              flex: 1,
              minHeight: 0,
              overflowY: 'auto',
              borderRadius: 2,
              boxShadow: 1
            }}
          >
            <Outlet />
          </Container>
        </Container>
      </Box>
    </>
  );
};

export default Login;
